export default "__VITE_ASSET__B4Eg8DOc__"